module.exports = __webpack_public_path__ + "static/media/badges-empty.1cad34d2.svg";